import React from 'react'
import { Link } from 'react-router-dom'
import journal from "./assets/document.png";
import verified from "./assets/verified.png";


const Questions = () => {
    return (
        <div style={{ marginTop: "5.5rem" }}>
            <div className="container">
                {/* Profile Card */}
                <div
                    className="row"
                    style={{ marginLeft: "2px", marginRight: "2px" }}
                >
                    <div className="col-6" style={{ padding: "5px" }}>
                        <Link
                            to="/verified-questions"
                            className="card card-hover rounded-4 shadow-sm p-10"
                        >
                            <div className="card-body text-center">
                                <img
                                    className="mb-2"
                                    src={verified}
                                    alt="Creative Idea"
                                    width={"50px"}
                                />
                                <h2 className="" style={{ fontSize: "15px" }}>
                                    Verified Questions
                                </h2>
                            </div>
                        </Link>
                    </div>
                    <div className="col-6" style={{ padding: "5px" }}>
                        <Link
                            to="/unverified-questions"
                            className="card card-hover rounded-4 shadow-sm"
                        >
                            <div className="card-body text-center">
                                <img
                                    className="mb-2"
                                    src={journal}
                                    alt="Creative Idea"
                                    width={"50px"}
                                />
                                <h2 className="" style={{ fontSize: "15px" }}>
                                    Unverified Questions
                                </h2>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Questions